import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { RequireAuth } from './components/RequireAuth.js';
import { UpdateBanner } from './components/UpdateBanner.js';
import { Admin } from './routes/admin/Admin.js';
import { Controle } from './routes/controle/Controle.js';
import { Entrar } from './routes/entrar/Entrar.js';
import { Convite } from './routes/convite/Convite.js';
import { Redefinir } from './routes/convite/Redefinir.js';
import { MinhaConta } from './routes/conta/MinhaConta.js';
import { Membros } from './routes/admin/Membros.js';
import { Plataforma } from './routes/admin/Plataforma.js';
import { Historico } from './routes/historico/Historico.js';
import { HistoricoPartida } from './routes/historico/Partida.js';
import { Home } from './routes/home/Home.js';
import { Inicio } from './routes/inicio/Inicio.js';
import { Parear } from './routes/parear/Parear.js';
import { Telao } from './routes/telao/Telao.js';

/**
 * Rotas.
 *
 * Duas entradas, porque são dois aparelhos: a **TV** abre `/telao` e nunca faz
 * login; o **celular** entra em `/entrar` e conduz o jogo. `/` é a bifurcação
 * para quem chega sem saber qual é qual.
 *
 * Tudo o que exige sessão passa por `RequireAuth`, que manda para
 * `/entrar?next=…` preservando o destino — quem abre o QR cai em
 * `/parear?c=ABC123`, e perder esse código no login significaria voltar à TV.
 */
export function App() {
  return (
    <BrowserRouter>
      {/* Global de propósito: a versão nova pode chegar com o operador em
          qualquer tela. Ele mesmo decide quando recarregar. */}
      <UpdateBanner />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/entrar" element={<Entrar />} />

        {/* A TV não faz login. */}
        <Route path="/telao" element={<Telao />} />

        {/* Convite e redefinição são públicos: quem chega aqui ainda não tem
            sessão — é justamente o que o link resolve. */}
        <Route path="/convite/:token" element={<Convite />} />
        <Route path="/redefinir/:token" element={<Redefinir />} />

        <Route
          path="/inicio"
          element={
            <RequireAuth>
              <Inicio />
            </RequireAuth>
          }
        />
        <Route
          path="/parear"
          element={
            <RequireAuth>
              <Parear />
            </RequireAuth>
          }
        />
        <Route
          path="/controle"
          element={
            <RequireAuth>
              <Controle />
            </RequireAuth>
          }
        />
        <Route
          path="/historico"
          element={
            <RequireAuth>
              <Historico />
            </RequireAuth>
          }
        />
        <Route
          path="/historico/partida/:gameId"
          element={
            <RequireAuth>
              <HistoricoPartida />
            </RequireAuth>
          }
        />
        <Route
          path="/minha-conta"
          element={
            <RequireAuth>
              <MinhaConta />
            </RequireAuth>
          }
        />
        <Route
          path="/admin/membros"
          element={
            <RequireAuth minimumRole="ADMIN">
              <Membros />
            </RequireAuth>
          }
        />
        <Route
          path="/admin/plataforma"
          element={
            <RequireAuth>
              <Plataforma />
            </RequireAuth>
          }
        />
        <Route
          path="/admin/*"
          element={
            <RequireAuth>
              <Admin />
            </RequireAuth>
          }
        />

        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
